import { render, staticRenderFns } from "./ScarDetail_practice.vue?vue&type=template&id=69054be1&scoped=true"
import script from "./ScarDetail_practice.vue?vue&type=script&lang=js"
export * from "./ScarDetail_practice.vue?vue&type=script&lang=js"
import style0 from "./ScarDetail_practice.vue?vue&type=style&index=0&id=69054be1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69054be1",
  null
  
)

export default component.exports